import { useDebugValue, useState } from 'react';

export const useStateWithLabel = (initialValue, name) => {
  const [value, setValue] = useState(initialValue);
  useDebugValue(`${name}:${JSON.stringify(value, null, 2)}`);
  return [value, setValue];
};
